module.exports = __webpack_public_path__ + "assets/img/logo.e908a1de.png";